import React, { useState } from 'react'
import { createBrandFormActions, onboardFormActions } from '../../store/createBrandFormState'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getImageUrl } from '../../utils/images'
import { UploadLogo } from '../Modals/UploadDocument/UploadLogo.Modal'
import { BrandColor } from '../../utils/constants'
import { SketchPicker, BlockPicker } from 'react-color'
import { insertHashupFront } from '../../helpers/string'

export const Brandlogo = ({ currentDocument, setDocument}) => {
  const navigator = useNavigate()
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState('tab2')
  const [openColourPaleteFlag, setOpenColourPaleteFlag] = useState(false)
  const onboardingData = useSelector(state => state.brandForm)
  const [backgroundColor, setBackgroundColor] = useState('#ffffff') // Default to white
  const [hexCode, setHexCode] = useState('#ffffff') // For the hex input field

  const [sketchPickerColor, setSketchPickerColor] = useState('#f17013')

  //creating state to store our color and also set color using onChange event for sketch picker

  // destructuring rgba from state
  const { r, g, b, a } = sketchPickerColor

  //creating state to store our color and also set color using onChange event for block picker
  const [blockPickerColor, setBlockPickerColor] = useState('#37d67a')

  const resetToWhite = () => {
    console.log('hahha')
    setSketchPickerColor('#ffffff')
    setBackgroundColor('#ffffff')
    setHexCode('#ffffff')
    setOpenColourPaleteFlag(false)
  }



  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
  const [icon, setIcon] = useState(false)

  const [documentName, setDocumentName] = useState('')

  const openModal = docName => {
    setIsDocumentModalOpen(true)
    setDocumentName(docName)
  }
  const closeModal = () => {setIsDocumentModalOpen(false);console.log("currentdoc 54",currentDocument);}
  const removelogo =()=>
  {
    setOpenColourPaleteFlag(false)
     return setDocument({
            file: "",
            isUploading: false,
            isUploaded: false,
            progress: 0,
            url: "",
            name: ""
        })
  }

  const handleTabClick = id => {
    console.log(id)
    setActiveTab(id)
    if (id === 'tab1') {
      resetToWhite()
      
    } 
  }

  const handleHexCodeChange = e => {

   
    setSketchPickerColor(insertHashupFront(e.target.value))
  }
  return (
    <div className='card card-light mb-3'>
      <div className='card-body'>
        <div className='row'>
          <div className='col-6'>
            <h5 className='font-weight-700 mb-4'>Brand logo</h5>
          </div>
          {currentDocument.url != '' &&  <div onClick={removelogo} className='col-6 text-right'>
            <p
              className='font-8 font-weight-600 text-uppercase text-danger'
              role='button'
            >
              remove logo
            </p>
          </div>}
        </div>

        <div className='btn-group btn-group-toggle mb-3' data-toggle='buttons'>
          {currentDocument.url != '' &&
            BrandColor.map((item, idx) => {
              return (
                <label
                  key={item.id}
                  id={`label-option${item.id}`}
                  onClick={() => handleTabClick(item.id)}
                  className={`btn brandlogo-item ${
                    activeTab === `${item.id}` ? 'active' : ''
                  }`}
                >
                  <input type='radio' name='options' hidden />
                  {item.label}
                </label>
              )
            })}

          {openColourPaleteFlag && (
            <div className='sketchpicker'>
          
              <SketchPicker
                onChange={color => {
                  console.log(color)

                  setSketchPickerColor(color.hex)
                }}
                color={sketchPickerColor}
              />
            </div>
          )}
        </div>

        {currentDocument.url != '' && activeTab==="tab2" && (
          <div className='form-group mb-3 color-box '>
            <div className='custom-control custom-switch color-pallte'>
              <input
                type='checkbox'
                className='custom-control-input'
                defaultChecked={false}
                onChange={(e) =>
                    {console.log("e",setOpenColourPaleteFlag(e.target.checked)  )}
                      } 
                for='customSwitch'
                id='customSwitch'
              />
              <label
                className='custom-control-label mb-2 font-weight-700'
                for='customSwitch'
               
              >
                show color palete
              </label>
            </div>

            <div>
              {' '}
              <input
                type='text'
                className='form-control'
                maxLength='7'
                style={{ textTransform: 'uppercase' }}
                value={sketchPickerColor}
                onChange={handleHexCodeChange}
                placeholder='Enter HEX code here (Eg: #000000)'
              />
            </div>

          
          </div>
        )}

        <div className='col-16'>
       



            {currentDocument.url === ''  &&  <div className='form-group'>
              <label role='button' className='mb-0'>
                <div className='card text-center shadow-none border-dashed'>
                  <div
                    className='card-body py-25 px-50'
                    onClick={() => openModal('')}
                  >
                    <img src={getImageUrl('icon-img.svg')} alt='img' />
                    <p className='my-2 font-10 text-grey font-weight-600'>
                      <span className='text-yellow-dark mr-2'>
                        Upload a file
                      </span>
                    </p>
                    <p className='mb-0 font-10 text-grey'>
                      (512px by 512px) up to 300KB PNG with transparent
                      background
                    </p>
                  </div>
                </div>
              </label>
            </div>}
           

            <UploadLogo
              setIcon={setIcon}
              currentDocument={currentDocument}
              setDocument={setDocument}
              show={isDocumentModalOpen}
              docName={documentName}
              close={closeModal}
            />
     
        </div>
{console.log("currentdocument 231",currentDocument)}
        {currentDocument.url != ''  && (
          <div style={{
            backgroundColor: sketchPickerColor,
            padding: '20px',
            marginTop: '20px'
          }} className='card shadow-none text-center py-4'>
            
              <div
                
              >
                <img
                  src={currentDocument.url}
                  alt='Uploaded Icon'
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            
          </div>
        )}
      </div>
    </div>
  )
}
